"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _runtimeConfigHelper = require("@eig-builder/core-utils/helpers/runtime-config-helper");

var _urlHelper = require("@eig-builder/core-utils/helpers/url-helper");

var urls = {
  dev: {
    upload: 'https://api.latest.storageservice.io/v1.0/images',
    uploadFromUrl: 'https://api.latest.storageservice.io/v1.0/images/url'
  },
  qa: {
    upload: 'https://api.qa.storageservice.io/v1.0/images',
    uploadFromUrl: 'https://api.qa.storageservice.io/v1.0/images/url'
  },
  uat: {
    upload: 'https://api.uat.storageservice.io/v1.0/images',
    uploadFromUrl: 'https://api.uat.storageservice.io/v1.0/images/url'
  },
  prod: {
    upload: 'https://api.storageservice.io/v1.0/images',
    uploadFromUrl: 'https://api.storageservice.io/v1.0/images/url'
  }
};

var StorageServiceUrlHelper = function StorageServiceUrlHelper() {
  (0, _classCallCheck2["default"])(this, StorageServiceUrlHelper);
};

exports["default"] = StorageServiceUrlHelper;

StorageServiceUrlHelper.getUrl = function (type) {
  var currentEnv = (0, _runtimeConfigHelper.getRuntimeConfig)()._env || 'dev';
  var url = (0, _urlHelper.getBaseUrl)(type);

  if (url) {
    return url;
  }

  if (Object.keys(urls[currentEnv]).indexOf(type) !== -1) {
    return urls[currentEnv][type];
  }

  return Error('No known type');
};